var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    fill: "currentColor",
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.416 6.817C19.49 1.553 17.42 0 16.318 0 14.6 0 14.158 1.3 10.5 1.344 6.842 1.301 6.4 0 4.682 0 3.58 0 1.509 1.553.582 6.817c-.528 3.006-1.1 7.492.265 8.03 1.7.67 2.277-1.005 4.144-2.421 1.895-1.435 2.804-1.773 5.51-1.773 2.704 0 3.613.338 5.508 1.773 1.867 1.415 2.444 3.092 4.144 2.422 1.366-.539.793-5.024.263-8.03ZM6.3 7.5c-1.16 0-2.1-.957-2.1-2.137 0-1.181.94-2.138 2.1-2.138 1.16 0 2.1.957 2.1 2.138 0 1.18-.94 2.137-2.1 2.137Zm7.35 0c-.58 0-1.05-.477-1.05-1.068 0-.591.47-1.07 1.05-1.07.58 0 1.05.479 1.05 1.07 0 .59-.47 1.068-1.05 1.068Zm2.1-2.137a1.06 1.06 0 0 1-1.05-1.069c0-.59.47-1.069 1.05-1.069.58 0 1.05.478 1.05 1.07 0 .59-.47 1.068-1.05 1.068Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/Session.84400a135975fbf174bedce9c8d09d1e.svg";
export { ForwardRef as ReactComponent };